import { apolloClient } from '../apolloClient'
import { SignUpInput } from '../GlobalTypes'
import { SIGN_UP } from './mutations/SIGN_UP'

export const signUp = async (input: SignUpInput) => {
  const response = await apolloClient.mutate({
    mutation: SIGN_UP,
    variables: { input: input },
  })

  return response.data
}
